import axios from "axios";

export default {
    GetData(context, advancedQueryCriteria) {
        let postData = {};
        if (advancedQueryCriteria.Realtional !== null || advancedQueryCriteria.MrAttributes !== null) {
            postData = advancedQueryCriteria;
        }

        return axios({
            url: `${process.env.VUE_APP_API_URL}/tag/data/${context.type}/${context.id}`,
            method: "POST",
            data: postData,
        });
    },
    GetNationalData(advancedQueryCriteria) {
        return axios({
            url: `${process.env.VUE_APP_API_URL}/tag/nationalData`,
            method: "POST",
            data: advancedQueryCriteria,
        });
    },
    GetMrAttributes() {
        return axios.get(`${process.env.VUE_APP_API_URL}/tag/retrieveIndexedMrAttributes`);
    },
};
